import { N } from '@angular/cdk/keycodes';

export const locale = {
  lang: 'en',
  data: {
    // COMMON
    ACTION: 'Action',
    ADD: 'Add',
    UPDATE: 'Update',
    DELETE: 'Delete',
    REMOVE: 'Remove',
    CLOSE: 'Close',
    CANCEL: 'Cancel',
    NONE: 'None',
    YES: 'Yes',
    NO: 'No',
    BACK: 'Back',
    GROUP: 'Group',
    SETTINGS: 'Settings',
    AREYOUSURE: 'Are you sure?',
    DELETEIT: 'Yes, delete it!',
    REVERTTHIS: "You won't be able to revert this!",
    DISMISS: 'Dismiss',
    DELETEDSUCCESSFULLY: 'Deleted successfully!',
    CREATEDSUCCESSFULLY: 'Created successfully!',
    UPDATEDSUCCESSFULLY: 'Updated successfully!',
    NORECORDSFOUND: 'No Records Found',
    NORECORDSDESCRIPTION: 'It seems there are no records available at the moment. Feel free to add new records to get started.',
    UPLOAD: 'Upload',
    CONSUMERCRITERIA: 'Consumer Criteria',
    POINTSREQUIREDISREQUIRED: 'Points required is required',
    INVALIDPOINTSREQUIRED: 'Invalid Points Required',
    DOWNLOAD: 'Download',
    EXPORTASEXCEL: 'Export as Excel',

    // MENU GROUPS
    CORE: 'Core',
    MARKETING: 'Marketing',
    COMMUNICATION: 'Communication',
    REWARDSDELIVERY: 'Rewards & Delivery',
    SYSTEM: 'System',
    DATAINSIGHT: 'Data Insight',
    ANALYTICS: 'Analytics',
    REPORTS: 'Reports',

    // MENU
    DASHBOARD: 'Dashboard',
    USERSCOUNT: 'Users Count',
    PARTNERS: 'Partners',
    PARTNER: 'Partner',
    PARTNERGROUP: 'Partner Group',
    STAFF: 'Staff',
    SYSTEMSETTINGS: 'System Settings',
    PRODUCTS: 'Products',
    CHANGESTATUS: 'Change Status',
    OTPENABLED: 'OTP Enabled',
    FRAUDDETECTIONENABLED: 'Fraud Detection Enabled',
    FRAUDDETECTIONHINT: 'Detect suspicious/fraudulent receipts only (e.g. arithmetic mismatches, invalid or missing receipt details). Does not check for reused receipts.',
    DUPLICATERECEIPTDETECTIONENABLED: 'Duplicate Receipt Detection Enabled',
    DUPLICATERECEIPTDETECTIONHINT: 'Prevent the same receipt from being used more than once. When off, users can scan and use the same receipt multiple times.',
    AIRECEIPTAUTHENTICITYENABLED: 'AI Receipt Authenticity Check',
    AIRECEIPTAUTHENTICITYHINT: 'When enabled, AI compares the scanned receipt against the original store receipt to detect manipulated or fake receipts. Adds an extra AI call during scanning.',
    STAFFWHATSAPPINVITEENABLED: 'Send WhatsApp password-setup link to new staff',
    STAFFWHATSAPPINVITEHINT: 'When on, new staff get a WhatsApp link to set their own password. When off, you set the password directly while creating the staff member.',
    LEBANESECURRENCYRATE: 'Lebanese Currency Rate',
    CATEGORYPROMPTID: 'Category Prompt ID',
    CATEGORYPROMPTVERSION: 'Category Prompt Version',
    STOREAPPVERSION: 'Store App Version',
    STOREAPPFORCEUPDATE: 'Store App Force Update Version',
    USERAPPVERSION: 'User App Version',
    USERAPPFORCEUPDATE: 'User App Force Update Version',
    IOSSTOREURL: 'iOS Store App URL',
    ANDROIDSTOREURL: 'Android Store App URL',
    IOSUSERURL: 'iOS User App URL',
    ANDROIDUSERURL: 'Android User App URL',
    TERMSANDCONDITIONS: 'Terms and Conditions',
    PRIVACYPOLICY: 'Privacy Policy',
    TERMSANDCONDITIONSUSERAPP: 'Terms and Conditions (User App)',
    PRIVACYPOLICYUSERAPP: 'Privacy Policy (User App)',
    TERMSANDCONDITIONSSTOREAPP: 'Terms and Conditions (Store App)',
    PRIVACYPOLICYSTOREAPP: 'Privacy Policy (Store App)',

    // SYSTEM SETTINGS TABS
    GENERAL: 'General',
    FEATURETOGGLES: 'Feature Toggles',
    PRICINGANDPROMPTS: 'Pricing & Prompts',
    MOBILEAPPS: 'Mobile Apps',
    APPVERSIONS: 'App Versions',
    APPVERSIONSHINT: 'Latest available version, and the minimum version below which users are forced to update.',
    STOREDOWNLOADLINKS: 'Store Download Links',
    STOREDOWNLOADLINKSHINT: 'Where users are sent to download or update each app.',
    RECEIPTS: 'Receipts',
    RECEIPTSCANLIMITS: 'Receipt Scan Limits',
    LEGAL: 'Legal',
    SETTINGSSAVENOTE: 'Changes across all tabs are saved together when you click Update.',
    PLEASEFIXHIGHLIGHTEDFIELDS: 'Please fix the highlighted fields before saving.',

    MAXRECEIPTSCANSPERMONTH: 'Max Receipt Scans Per Month',
    MAXRECEIPTSCANSPERMONTHHINT: '0 = unlimited. Resets on the 1st of each month.',
    MAXWRONGRECEIPTSCANSPERMONTH: 'Max Invalid Receipt Scans Per Month',
    MAXWRONGRECEIPTSCANSPERMONTHHINT: '0 = unlimited. Resets on the 1st of each month.',
    MAXRECEIPTAGEDAYS: 'Max Receipt Age (Days)',
    REJECTIONREASON: 'Rejection Reason',

    //LOGIN
    ENTERMOBILE: 'Enter mobile number',
    ENTERPASSWORD: 'Enter your password',
    ENTEROTP: 'Enter the OTP',
    OTPREQUIRED: 'OTP is required',
    REMEMBERME: 'Remember me',
    FORGOTPASSWORD: 'Forgot your password?',
    LOGIN: 'Log In',
    PASSWORDS: 'Password',
    PASSWORDREQUIRED: 'Password is required',

    // LOGOUT
    LOGOUT: 'Logout',
    WANTTOLOGOUT: 'Are you sure you want to logout?',
    YESLOGOUT: 'Yes, Logout!',

    // PARTNERS
    NAME: 'Name',
    ADDITIONALINFO: 'Additional Info',
    CREATEDTIME: 'Created Time',
    SEARCH: 'Search here..',
    UPDATEPARTNERGROUP: 'Update Partner Group',
    ADDNEWPARTNERGROUP: 'Add New Partner Group',
    NAMEISREQUIRED: 'Name is required',
    INVALIDNAME: 'Invalid name',
    INVALIDADDITIONALINFO: 'Invalid additional info',
    OFFERS: 'Offers',
    LOCATION: 'Location',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    PARTNERTYPE: 'Partner Type',
    UPDATEPARTNER: 'Update Partner',
    ADDNEWPARTNER: 'Add New Partner',
    DESCRIPTION: 'Description',
    STREETNUMBER: 'Street Number',
    ADDRESS: 'Address',
    CITY: 'City',
    ZIPCODE: 'ZipCode',
    PARTNERGROUPISREQUIRED: 'Partner Group is required',
    DESCRIPTIONISREQUIRED: 'Description is required',
    STREETNUMBERISREQUIRED: 'Street Number is required',
    ADDRESSISREQUIRED: 'Address is required',
    CITYISREQUIRED: 'City is required',
    ZIPCODEISREQUIRED: 'Zip Code is required',
    INVALIDDESCRIPTION: 'Invalid description',
    INVALIDSTREETNUMBER: 'Invalid street number',
    INVALIDADDRESS: 'Invalid address',
    INVALIDCITY: 'Invalid city',
    INVALIDZIPCODE: 'Invalid zipcode',
    INVALIDLOCATION: 'Invalid location',
    LATITUDEISREQUIRED: 'Latitude is required',
    LONGITUDEISREQUIRED: 'Longitude is required',
    INVALIDLATITUDE: 'Latitude must be between -90 and 90',
    INVALIDLONGITUDE: 'Longitude must be between -180 and 180',
    FIRSTNAME: 'First Name',
    FIRSTNAMEISREQUIRED: 'First name is required',
    INVALIDFIRSTNAME: 'Invalid first name',
    LASTNAME: 'Last Name',
    LASTNAMEISREQUIRED: 'Last name is required',
    INVALIDLASTNAME: 'Invalid last name',
    MOBILENUMBER: 'Mobile Number',
    MOBILENUMBERISREQUIRED: 'Mobile number is required',
    INVALIDMOBILENUMBER: 'Invalid mobile number',
    EMAIL: 'Email',
    EMAILISREQUIRED: 'Email is required',
    INVALIDEMAIL: 'Invalid email',
    ROLES: 'Roles',
    ROLESISREQUIRED: 'Roles is required',
    INVALIDROLES: 'Invalid roles',
    ISACTIVE: 'Is Active',
    ISACTIVEISREQUIRED: 'Is active is rerquired',
    PASSWORD: 'Password',
    PASSWORDISREQUIRED: 'Password is required',
    INVALIDPASSWORD: 'Invalid password',
    STORETYPE: 'Store Type',
    PARTNERDASHBOARD: 'Partner Dashboard',
    REWARDCLAIMED: 'Reward Claimed',
    SPINWON: 'Spin Won',
    SUBSCRIPTIONTYPE: 'Subscription Type',
    INVALIDIMAGEURLENTERAVALIDIMAGE: ' Invalid image URL. Please enter a valid URL for an image.',
    IMAGEUPLOADFAILED: 'Image upload failed. Please try again.',
    PARTNERINFORMATION: 'Partner Information',
    FULLNAME: 'Full Name',
    VIEW: 'View',
    SELECTLOCATION: 'Select Location',
    SELECTUSINGMAP: 'Select Using Map',
    PASSWORDMINLENGTHSHOULDBE8: 'Password minlength should be 8',
    PASSWORDINVALIDFORMAT: 'Password invalid format',
    ISCHATDISABLED: 'Is Chat Disabled',
    ISCHATDISABLEDISREQUIRED: 'Is chat disabled is required',
    PARTNERTYPEISREQUIRED: 'Partner Type is required',
    PROMPTID: 'Prompt ID',
    PROMPTVERSION: 'Prompt Version',
    NAMEONRECEIPT: 'Name on Receipt',
    ORIGINALRECEIPTIMAGE: 'Original Store Receipt (optional)',
    ORIGINALRECEIPTHINT: 'Upload one or more photos of a genuine receipt from this store. Used by the AI Receipt Authenticity Check as a reference. Optional.',
    COMPANYNAME: 'Company Name',
    COMPANYNAMEISREQUIRED: 'Company Name is required',
    INVALIDCOMPANYNAME: 'Invalid company name',
    IFPRODUCERDELETE: 'If the producer is deleted, all related data will also be deleted.',

    // PRODUCT
    STOCK: 'Stock',
    ENDDATE: 'End Date',
    STARTDATE: 'Start Date',
    POINTSEARNED: 'Points Earned',
    BRAND: 'Brand',
    CATEGORY: 'Category',
    PRODUCTNAME: 'Product Name',
    PRODUCTDETAILS: 'Product Details',
    PRODUCTIMAGE: 'Product Image',
    LINK: 'Link',
    UPDATEPRODUCT: 'Update Product',
    ADDNEWPRODUCT: 'Add New Product',
    CATEGORYISREQUIRED: 'Category is required',
    INVALIDCATEGORY: 'Invalid category',
    BRANDISREQUIRED: 'Brand is required',
    INVALIDBRAND: 'Invalid brand',
    VALIDSTARTDATETIME: 'Valid Start Date Time',
    VALIDSTARTDATETIMEISREQUIRED: 'Valid start date time is required',
    INVALIDVALIDSTARTDATETIME: 'Invalid valid start date time',
    VALIDENDDATETIME: 'Valid End Date Time',
    VALIDENDDATETIMEISREQUIRED: 'Valid end date time is required',
    INVALIDVALIDENDDATETIME: 'Invalid valid end date time',
    PRODUCERISREQUIRED: 'Producer is required',
    INVALIDPRODUCER: 'Invalid producer',
    // BARCODE: 'Bar Code',
    BARCODEISREQUIRED: 'Bar code is required',
    INVALIDBARCODE: 'Invalid bar code',
    POINTSEARNEDISREQUIRED: 'Points earned is required',
    INVALIDPOINTSEARNED: 'Invalid points earned',
    IMAGEURL: 'Image Url',
    IMAGEURLISREQUIRED: 'Image url is required',
    INVALIDIMAGEURL: 'Invalid image url',
    EXTERNALURL: 'External Url',
    INVALIDEXTERNALURL: 'Invalid external url',
    SKU: 'Sku',
    SKUISREQUIRED: 'Sku is required',
    INVALIDSKU: 'Invalid sku',
    PRODUCER: 'Producer',
    UPLOADPRODUCTS: 'Upload Products',
    VALIDPRODUCTS: 'Valid Products',
    EXCELFILE: 'Excel File',
    DOWNLOADSAMPLEXLSX: 'Download Sample XLSX',
    ESTIMATEDPRICE: 'Estimated Price',
    ESTIMATEDPRICEISREQUIRED: 'Estimated Price is required',
    INVALIDESTIMATEDPRICE: 'Invalid estimated price',
    SUBCATEGORY: 'Subcategory',
    NOTAVAILABLE: 'Not Available',
    EXPAND: 'Expand',
    UPDATECATEGORY: 'Update Category',
    ADDNEWCATEGORY: 'Add New Category',
    SUBCATEGORYISREQUIRED: 'Subcategory is required',
    PRODUCTNAMEALREADYEXISTSFORBRAND: 'Product Name already exists in this brand',
    QUESTIONALREADYEXISTS: 'Question already exists',
    INVALIDSUBCATEGORY: 'Invalid subcategory',
    INVALIDSUBCATEGORY1: 'Invalid subcategory 1',
    INVALIDSUBCATEGORY2: 'Invalid subcategory 2',
    INVALIDSUBCATEGORY3: 'Invalid subcategory 3',
    EXCELFILEISREQUIRED: 'Excel File is required',
    CATEGORYSUBCATEGORYNOTMATCHING: 'Category and subcategory are not matching in ',
    SUBCATEGORY1SUBCATEGORY2NOTMATCHING: 'Subcategory 1 and subcategory 2 are not matching in ',
    SUBCATEGORY2SUBCATEGORY3NOTMATCHING: 'Subcategory 2 and subcategory 3 are not matching in ',
    VALIDATIONERRORINUPLOADEDDATA: 'Validation error in the uploaded data. Please check and correct the errors.',
    EXCELSHEETSTARTDATECANNOTBEAFFTERENDDATE: 'Start date cannot be after End date for product ',
    SELECTCATEGORYORSUBCATEGORY: 'Please select valid category or subcategory in ',
    DROPFILESHERE: 'Drop files here or click to upload.',
    ISSPECIALPRODUCT: 'Is Special Product',
    ISBUNDLEPRODUCT: 'Is Bundle Product',
    ISSPECIALPRODUCTISREQUIRED: 'Is Special Producet is required',
    ISBUNDLEPRODUCTISREQUIRED: 'Is Bundle Producet is required',
    BUNDLEITEMS: 'Bundle Items',
    SPECIALPRODUCT: 'Special Product',
    BUNDLE: 'Bundle',
    // AUDIT LOG
    AUDITLOG: 'Audit Log',
    USER: 'User',
    EVENT: 'Event',
    TIMESTAMP: 'Timestamp',
    INFO: 'Info',

    // OFFER
    OFFER: 'Offer',
    INFONOTE: 'Info Note',
    INVALIDINFONOTE: 'Invalid info note',
    SELECTPRODUCER: 'Select Producer',
    ENTERDESCRIPTION: 'Enter Description',
    STARTDATETIME: 'Start Date Time',
    ENTERSTARTDATETIME: 'Enter Start Date Time',
    ENDDATETIME: 'End Date Time',
    ENTERENDDATETIME: 'Enter End Date Time',
    STATUS: 'Status',
    ENTERSTATUS: 'Enter Status',
    ENTERIMAGEURL: 'Enter Image Url',
    NEXT: 'Next',
    STARTDATETIMEISREQUIRED: 'Start date time is required',
    INVALIDSTARTDATETIME: 'Invalid start date time',
    STATUSISREQUIRED: 'Status is required',
    INVALIDSTATUS: 'Invalid status',
    ENDDATETIMEISREQUIRED: 'End date time is required',
    INVALIDENDDATETIME: 'Invalid end date time',
    OFFERDETAILS: 'Offer Details',
    PRODUCTSINOFFER: 'Products In Offer',
    ADDUPDATE: 'Add/Update',
    UPDATEOFFER: 'Update Offer',
    QUANTITY5: 'You want to give reward with quantity of',
    QUANTITY10: 'To add quantities above 10, please get in touch with support.',
    OKAY: 'Ok',
    NOREWARDS: 'No Rewards',
    CREATEREWARDSBYCLICKINGADDBUTTON: 'Please create rewards by clicking the add (+) button in the right corner',
    OFFERMONEYREWARDS: 'Offer Money Rewards',
    TOTALREWARDCOUNT: 'Total Reward Count',
    TOTALREWARDMONEY: 'Total Reward Money',
    USERREWARDDETAILS: 'User Reward Details',
    VIEWREWARDUSERS: 'View Reward Users',

    // RATE
    RATE: 'Rate',
    SELECTOFFER: 'Select Offer',
    OFFERISREQUIRED: 'Offer is required',
    INVALIDOFFER: 'Invalid offer',
    SPEED: 'Speed',
    ENTERSPEED: 'Enter Speed',
    SPEEDISREQUIRED: 'Speed is required',
    INVALIDSPEED: 'Invalid speed',
    CYCLE: 'Cycle',
    ARCHIEVE: 'Archieve',
    ARCHIEVED: 'Archieved',
    ARCHIEVEDSUCCESSFULLY: 'Archieved Successfully',
    UPDATESTATUS: 'Update Status',
    NEWSTATUS: 'New Status',
    WEEKNUMBER: 'Week Number',
    ARCHIEVEREMOVEDSUCCESSFULLY: 'Archieve removed Successfully',
    REMOVEFROMARCHIEVE: 'Remove from Archieve',
    CYCLEISREQUIRED: 'Cycle is required',
    CYCLESTARTDATETIME: 'Cycle Start Date Time',
    ENTERCYCLESTARTDATETIME: 'Enter Cycle Start Date Time',
    CYCLEENDDATETIME: 'Cycle End Date Time',
    ENTERCYCLEENDDATETIME: 'Enter Cycle End Date Time',
    PRIORITY: 'Priority',
    ENTERPRIORITY: 'Enter Priority',
    PRIORITYISREQUIRED: 'Priority is required',
    INVALIDPRIORITY: 'Invalid Priority',
    ISRECURRENCE: 'Is Recurrence',
    ISRECURRENCEISREQUIRED: 'Is Recurrence is required',
    RECURRENCEINTERVAL: 'Recurrence interval',
    ENTERRECURRENCEINTERVAL: 'Enter recurrence interval',
    MAXRECURRENCES: 'Max Recurrences',
    SEARCHLOCATION: 'Search Location',
    TYPEADDRESS: 'Select Location',
    ENTERMAXRECURRENCES: 'Enter max recurrences',
    RECURRENCESPECIFICDAYS: 'Recurrence Specific Days',
    ENTERRECURRENCESPECIFICDAYS: 'Enter Recurrence Specific Days',
    RECURRENCEEXCLUDIONS: 'Recurrence Excludions',
    ENTERRECURRENCEEXCLUDIONS: 'Enter Recurrence Excludions',
    JUSTONETIMEPERCYCLE: 'Just One Time Per Cycle',
    ENTERJUSTONETIMEPERCYCLE: 'Enter Just One Time Per Cycle',
    TARGETCOUNTRIES: 'Target Countries',
    ENTERTARGETCOUNTRIES: 'Enter Target Countries',
    TARGETSTATES: 'Target States',
    ENTERTARGETSTATES: 'Enter Target States',
    TARGETCITIES: 'Target Cities',
    ENTERTARGETCITIES: 'Enter Target Cities',
    TARGETGENDERS: 'Target Genders',
    ENTERTARGETGENDERS: 'Enter Target Genders',
    TARGETSTORES: 'Target Stores',
    ENTERTARGETSTORES: 'Enter Target Stores',
    TARGETPREFERENCE: 'Target Preference',
    ENTERTARGETPREFERENCE: 'Enter Target Preference',
    TARGETPROFILE: 'Target Profile',
    ENTERTARGETPROFILE: 'Enter Target Profile',
    LOYALTOCOMPETITOR: 'Loyal To Competitor',
    ENTERLOYALTOCOMPETITOR: 'Enter Loyal To Competitor',
    TARGETMINLOYALTYLEVEL: 'Target Min Loyal Level',
    ENTERTARGETMINLOYALTYLEVEL: 'Enter Target Min Loyal Level',
    TARGETMAXLOYALTYLEVEL: 'Target Max Loyalty Level',
    ENTERTARGETMAXLOYALTYLEVEL: 'Enter Target Max Loyalty Level',
    ADDNEWRATE: 'Add New Rate',
    UPDATERATE: 'Update Rate',
    INVALIDTARGETPROFILE: 'Invalid target profile',
    INVALIDTARGETPREFERENCE: 'Invalid target preference',
    INVALIDRECURRENCESPECIFICDAYS: 'Invalid recurrence specific days',
    UPDATEBANNER: 'Update Banner',

    // NEWS
    NEWS: 'News',
    TITLE: 'Title',
    CONTENT: 'Content',
    CREATEDAT: 'Created At',
    REVIEWSTATUS: 'Review Status',
    ADDCOMMENTS: 'Add Comments',
    STATUSUPDATE: 'Status Update',
    REVIEW: 'Review',
    LIKES: 'Likes',
    ADDNEWNEWS: 'Add New News',
    ADDNEWS: 'Add News',
    UPDATENEWS: 'Update News',
    TITLEISREQUIRED: 'Title is required',
    INVALIDTITLE: 'Invalid title',
    PARTNERISREQUIRED: 'Partner is required',
    INVALIDPARTNER: 'Invalid partner',
    MAXNEWSCOUNTREACHED: 'Maximum news count reached',
    LATESTOFFERSINSIDE: 'Latest offers inside!',
    CHECKTHEPRODUCT: 'Check the Product',
    PREVIEWURL: 'Preview Url',
    URL: 'URL(Optional)',
    NEWSTYPE: 'News Type',
    NAMENOTDISPLAYEDINTHENEWS: 'Name(Not displayed in the news)',
    DESCRIPTIONNOTDISPLAYEDINTHENEWS: 'Description(Not displayed in the news)',
    IMAGE01: 'Image 01',
    IMAGE02OPTIONAL: 'Image 02(Optional)',
    IMAGE03OPTIONAL: 'Image 03(Optional)',
    VIDEO: 'Video',
    PROMOTIONALOFFER: 'Promotional Offer',
    NOOFTIMEPROMOTIONISGIVEN: 'Number of time the promotion is given',
    CONTENTISREQUIRED: 'Content is required',
    INVALIDCONTENT: 'Invalid content',
    NEWSTYPEISREQUIRED: 'News Type is required',
    IMAGEISREQUIRED: 'Image is required',
    VIDEOURLISREQUIRED: 'Video URL is required',
    NORECORDAVAILABLE: 'No Record Available',
    INVALIDURL: 'Invalid URL',
    INVALIDIMAGE02: 'Inavlid Image 02',
    INVALIDIMAGE03: 'Inavlid Image 03',
    PROMOTIONALOFFERISREQUIRED: 'Promotional Offer is required',
    NOOFTIMEPROMOTIONISGIVENISREQUIRED: 'Number of time the promotion is given is required',
    INVALIDNOOFTIMEPROMOTIONISGIVEN: 'Invalid number of time the promotion is given',
    CONTENTMUSTBELESSTHAN280CHARACTERS: 'Content must be less than 280 characters',
    ONLYONEDECIMALALLOWED: 'Only one decimal allowed',
    MUSTBEVALIDNUMBER: 'Please enter a valid number',
    NUMBEROFTIMEPROMOTIONISGIVEN: 'No of time promotional is given',

    // ADS -BANNER
    ADDNEWBANNER: 'Add New Banner',
    BANNER: 'Banner',
    TARGETPREFERENCES: 'Target Preferences',
    TARGETPROFILES: 'Target Profiles',
    INVALIDTARGETPREFERENCES: 'Invalid target preferences',
    INVALIDTARGETPROFILES: 'Invalid target profiles',
    INVALIDLOYALTOCOMPETITOR: 'Invalid loyal to competitor',
    INVALIDTARGETMAXLOYALTYLEVEL: 'Invalid target max loyalty level',
    INVALIDTARGETMINLOYALTYLEVEL: 'Invalid target min loyalty level',
    INVALIDTARGETGENDERS: 'Invalid target genders',
    INVALIDTARGETCITIES: 'Invalid target cities',
    INVALIDTARGETSTATES: 'Invalid target states',
    INVALIDTARGETCOUNTRIES: 'Invalid target countries',
    BANNERTARGETDESCRIPTION: 'Select parameters to tailor Banner to specific target consumers',
    BANNERCLICKCOUNT: 'Banner Click Count',
    BANNERCLICKUSERLIST: 'Banner Click User List',
    MAXBANNERCOUNTREACHED: 'Maximum banner count reached',
    MAXIMAGESIZEVALIDATION: 'The allowed dimensions of image (1500x500).',
    MAXBANNERCOUNTREACHEDDISABLEABANNERTHENENABLE: 'The maximum banner count has been reached. Please disable an existing banner before enabling the required one.',

    // RECEIPT
    RECEIPT: 'Receipt',
    TOTALREWARDSCLAIMED: 'Total Rewards Claimed',
    TOTALAMOUNTINOFFER: 'Total Amount In Offer',
    TOTALITEMSINOFFER: 'Total Items In Offer',
    TOTALAMOUNT: 'Total amount',
    CAPTUREDDATETIME: 'Captured Date Time',
    RECEIPTNUMBER: 'Receipt Number',
    PROCESSED: 'Processed',
    NOTPROCESSED: 'Not Processed',
    WHOLENUMBERONLY: 'Invalid value. Only whole numbers are accepted here.',
    QUANTITY2000: 'To add quantities above 2000, please get in touch with support.',

    // CONSUMER
    CONSUMER: 'Consumer',
    PRDOUCERNAME: 'Producer Name',
    USERPARTNERLOYATYSCREEN: 'User Partner Loyalty Screen',
    CAPTUREDDATTIME: 'Captured Date Time',
    VIEWRECEIPT: 'View Receipt',
    USERPARTNERLOYALTYLIST: 'User Partner Loyalty List',
    CORRECT: 'Correct',
    NOTCORRECT: 'Not Correct',

    //OFFERLIST
    OFFERLIST: 'Offer List',
    PRODUCTOFFERLINK: 'Product Offer Link',
    PRODUCT: 'Product',
    PRODUCTISREQUIRED: 'Product is required',
    ADDNEWOFFER: 'Add New Offer',
    INVALIDPRODUCT: 'Invalid product',
    OFFERIMAGE: 'Offer Image',

    //REWARD
    REWARDS: 'Rewards',
    ADDREWARDTIER: 'Add Reward Tier',
    UPDATEREWARDTIER: 'Update Reward Tier',
    ADDREWARD: 'Add Reward',
    ADDNEWREWARDTIER: 'Add New Reward Tier',
    COLOR: 'Color',
    POINTSREQUIRED: 'Points Required',
    INVALIDCOLOR: 'Invalid color',
    COLORISREQUIRED: 'Color is required',
    REWARDIMAGE: 'Reward Image',
    AVAILABLEBRANCHISREQUIRED: 'Available branch is required',
    DELETEREWARD: 'Delete Reward',
    DELETEVOUCHERSBEFOREDELETEREWARD: 'Please delete the vouchers before deleting the reward.',
    MAXIMUMNUMBEROFREWARDSGIVEN: 'Maximum number of rewards given',
    VALUESHOULDBEBETWEEN1AND100: 'Value should be between 1 - 100',
    VALUESHOULDBEBETWEEN1AND3: 'Value should be between 1.1 - 3',
    ONLYINTEGERALLOWEDFORPOINTS: 'Only integer allowed for points',
    PLEASESELECTVALIDBARCODE: 'Please select a valid barcode. This barcode is not associated with any product.',
    MAXIMUMNUMBEROFREWARDSGIVENISREQUIRED: 'Maximum number of rewards given is required',
    INVALIDNUMBEROFREWARDISGIVEN: 'Invalid number of reward is given',
    MAXIMUMNUMBEROFREWARDSMUSTBEGREATERTHANZERO: 'Must be greater than zero',
    PLEASEGIVESPECIALPRODUCTBARCODE: 'Please give special product barCode',
    BARCODESHOULDUNIQUEONSELECTEDOFFER: 'Barcode should be unique for the selected offer.',
    UPDATEAVAILABLEBRANCHSTOREWARD: 'Update Available Branchs To Rewards',
    VALIDREWARDS: 'Valid Rewards',

    //PRODUCTOFFERLINK
    UPDATEPRODUCTOFFERLINK: 'Update Product Offer Link',
    ADDNEWPRODUCTOFFERLINK: 'Add New Product Offer Link',
    BRANDSINOFFER: 'Brands In Offer',
    VIEWMORE: 'View more',

    //REWARDTIER
    REWARDTIER: 'Reward Tier',
    REWARDTIERIDISREQUIRED: 'Reward tier id is required',
    INVALIDREWARDTIER: 'Invalid reward tier',
    AVAILABLESTORES: 'Availables Stores',
    INVALIDAVAILABLESTORES: 'Invalid availble stores',
    MAXVOUCHERCOUNT: 'Max Voucher Count',
    MAXVOUCHERCOUNTISREQUIRED: 'Max voucher count is required',
    INVALIDMAXVOUCHERCOUNT: 'Invalid max voucher count',
    VOUCHERREMAINING: 'Voucher Remaining',
    VOUCHERREMAININGISREQUIRED: 'Voucher remaining is required',
    INVALIDVOUCHERREMAINING: 'Invalid voucher remaining',
    INVALIDISACTIVE: 'Invalid is active',
    UPDATEREWARD: 'Update Reward',
    ADDNEWREWARD: 'Add New Reward',
    REWARDKIND: 'Reward Kind',
    REWARDKINDISREQUIRED: 'Reward kind is required',
    MONEYAMOUNTMINOR: 'Amount in minor units',
    CURRENCY: 'Currency',
    CURRENCYISREQUIRED: 'Currency is required',
    INVALIDCURRENCY: 'Currency must be a 3-letter ISO code',
    CYCLESTARTDATETIMEISREQUIRED: 'Cycle start date time is required',
    CYCLEENDDATETIMEISREQUIRED: 'Cycle end date time is required',
    DELETEREWARDTIER: 'Delete Reward Tier',

    //VOUCHER
    ADDVOUCHER: 'Add Voucher',
    UPDATEVOUCHER: 'Update Voucher',
    ADDNEWVOUCHER: 'Add New Voucher',
    INVALIDVALIDMINS: 'Invalid valid mins',
    VOUCHERCODEREQUIRED: 'Voucher code is required',
    STOREISREQUIRED: 'Store is required',
    VALIDMINS: 'Valid Mins',
    INVALIDVOUCHERCODE: 'Invalid voucher code',
    VOUCHERCODE: 'Voucher Code',
    STORE: 'Store',
    STARTANDEND: 'Start & End',
    ACTIONS: 'Actions',
    VOUCHERS: 'Vouchers',
    VALIDMINSISREQUIRED: 'Valid Mins is required',
    VOUCHERCODEREGENERATE: 'Voucher code regenerate',
    VOUCHERCODELENGTH: 'Voucher code must be exactly 12 characters long.',
    REWARDBARCODE: 'Reward Bar Code',
    USEDDATE: 'Used Date',
    UPLOADVOUCHERS: 'Upload Voucher',
    VALIDVOUCHERS: 'Valid Vouchers',
    USED: 'Used',
    NOTUSED: 'Not Used',
    VOUCHERUSEDFLAG: 'Voucher Used Flag',
    REWARDBARCODEISREQUIRED: 'Reward Bar Code is required',
    STORENAMEISREQUIRED: 'Store Name is required',

    //CONSUMER
    DATEOFBIRTH: 'Date Of Birth',
    GENDER: 'Gender',
    RECEIPTSCREEN: 'Receipt Screen',
    RECEIPTFILEIMAGE: 'Receipt File Image',
    TOTALITEMSPURCHASED: 'Total Items Purchased',
    TOTALREWARDCLAIMED: 'Total Reward Claimed',
    TOTALAMOUNINOFFER: 'Total Amount In Offer',
    RECEIPTDATETIME: 'Receipt Date Time',
    RECEIPTFILEURL: 'Receipt File Url',
    SUMMARY: 'Summary',
    REWARD: 'Reward',
    VOUCHER: 'Voucher',
    REWARDSCREEN: 'Reward Screen',
    POINTSUSED: 'Points Used',
    OFFERNAME: 'Offer Name',
    OFFERSTARTDATETIME: 'Offer Start Date Time',
    OFFERENDDATETIME: 'Offer End Date Time',
    GENERATEDDATTIME: 'Generated Date Time',
    PRODUCTEXTERNALURL: 'Product Extranal Url',
    VOUCHERSCREEN: 'Voucher Screen',
    GENERATEDDATETIME: 'Generated Date Time',
    REWARDNAME: 'Reward Name',
    VOUCHERGENERATEDDATTIME: 'Voucher Generate Date Time',
    VOUCHERSTARTDATETIME: 'Voucher Start Date Time',
    VOUCHERENDDATETIME: 'Voucher End Date Time',
    ISPROCESSED: 'Is Processed',
    PREVIEW: 'Preview',
    RECEIPTPRODUCTMAPPING: 'Receipt Product Mapping',
    POINTS: 'Points',
    POINTSISREQUIRED: 'Points is required',
    INVALIDPOINTS: 'Invalid points',
    QUANTITY: 'Quantity',
    QUANTITYISREQUIRED: 'Quantity is required',
    INVALIDQUANTITY: 'Invalid quantity',
    AMOUNT: 'Amount',
    AMOUNTISREQUIRED: 'Amount is required',
    INVALIDAMOUNT: 'Invalid amount',
    ISPARTOFOFFER: 'Is Part Of Offer',
    ISPARTOFOFFERISREQUIRED: 'Is part of offer is required',
    ISREDEEMED: 'Is Redeemed',
    UPDATECONSUMER: 'Update Consumer',
    ADDNEWCONSUMER: 'Add New Consumer',
    GENDERISREQUIRED: 'Gender is required',
    OFFERSCREEN: 'Offer Screen',
    TOTALPOINTSEARNED: 'Total Points Earned',
    TOTALREMAININGPOINTS: 'Total Remaining Points',
    TOTALVOUCHERREDEEMED: 'Total Voucher Redeemed',
    TOTALEURO: 'Total Euro',
    TOTALPRODUCTS: 'Total Products',
    INVALIDDATEOFBIRTH: 'Invalid date of birth',
    DATEOFBIRTHISREQUIRED: 'Date Of Birth is required',
    SUMMARYSCREEN: 'Summary Screen',
    REDEEMED: 'Redeemed',
    NOTREDEEMED: 'Not Redeemed',
    ISCHATBLOCKED: 'Is Chat Blocked',
    CHATBLOCKEDREASON: 'Chat Blocked Reason',
    INVALIDCHATBLOCKEDREASON: 'Invalid chat blocked reason',
    ISCHATBLOCKEDISREQUIRED: 'Is chat blocked is required',

    //Profile Management
    PROFILEMANAGEMENT: 'Profile Management',
    SAVECHANGES: 'Save Changes',
    CHANGEPASSWORD: 'Change Password',
    PROFILE: 'Profile',
    ABOUTME: 'About Me',

    //Dashboard
    USERS: 'Users',
    VS: 'vs.',
    PREVIOUSWEEK: 'Previous Week',
    NOTPROCESSEDRECEIPT: 'Not Processed Receipt',
    VOUCHERSREDEEMED: 'Vouchers Redeemed',
    PROCESSEDRECEIPT: 'Processed Receipt',
    USEROVERVIEW: 'User Overview',
    TODAY: 'Today',
    LASTMONTH: 'Last Month',
    LASTYEAR: 'Last Year',
    ALLTIME: 'All Time',
    VOUCHERREDEEMED: 'Voucher Redeemed',
    RECEIPTSCANS: 'Receipt Scans',
    USERVISITS: 'User Visits',

    //Spin
    SPIN: 'Spin',
    SPINQUESTION: 'Spin Question',
    SPINREWARD: 'Spin Reward',
    QUESTION: 'Question',
    TYPE: 'Type',
    OPTIONS: 'Options',
    ASKEDCOUNT: 'Asked Count',
    VALUE: 'Value',
    WONCOUNT: 'Won Count',
    IMAGE: 'Image',
    SPINSCREEN: 'Spin Screen',
    SPINDATE: 'Spin Date',
    REWARDTYPE: 'Reward Type',
    REWARDVALUE: 'Reward Value',
    ANSWEREDCORRECTLY: 'Answered Correctly',
    CORRECTOPTION: 'Correct Option',
    UPDATESPINQUESTION: 'Update Spin Question',
    ADDNEWSPINQUESTION: 'Add New Spin Question',
    TYPEISREQUIRED: 'Type is required',
    QUESTIONISREQUIRED: 'Question is required',
    OPTIONSISREQUIRED: 'Options is required',
    INVALIDOPTIONS: 'invalid options',
    CORRECTOPTIONISREQUIRED: 'Correct option is required',
    INVALIDCORRECTOPTION: 'Invalid correct option',
    INVALIDQUESTION: 'Invalid Question',
    INVALIDTYPE: 'Invalid type',
    ONLY4OPTIONSALLOWED: 'Only 4 options allowed.',
    ADDNEWSPINREWARD: 'Add New Spin Reward',
    UPDATESPINREWARD: 'Update Spin Reward',
    DETAILS: 'Details',
    DETAILSISREQUIRED: 'Details is required',
    INVALIDDETAILS: 'Invalid details',
    INVALIDVALUE: 'Invalid value',
    REWARDISREQUIRED: 'Reward is required',
    VALUEISREQUIRED: 'Value is required',
    ADDONLY4OPTIONS: 'You can only add up to 4 options',
    TOTALQUANTITYALLOCATED: 'Total Quantity Allocated',
    TOTALNOOFSEGMENTS: 'Total No. Of Segments',
    CHOOSEREWARD: 'Choose Reward',
    QUANTITYALLOCATED: 'Qty Allocated',
    NOOFSEGMENTS: 'No. Of Segments',
    BRANZEEQUESTION: 'Branzee Question',
    PLEASESELECTABRAND: 'Please select a brand',
    QTYALLOCATEDISREQUIRED: 'Qty Allocated is required',
    NOOFSEGMENTSISREQUIRED: 'No. Of Segments is required',
    NOPRODUCTAVAILABLE: 'No Product Available',
    QUESTIONNOTAVAILABLE: 'Question not available',
    PRODUCTSUB3: 'Product (Sub3)',
    UPCOMINGSPIN: 'Upcoming Spin',
    SUBMIT: 'Submit',
    PLEASEADDATLEAST2OPTIONS: 'Please add at least 2 options',

    //Change Password
    CONFIRMPASSWORD: 'Confirm Password',
    NEWPASSWORD: 'New Password',
    OLDPASSWORD: 'Old Password',
    OLDPASSWORDISREQUIRED: 'Old Password is required',
    NEWPASSWORDISREQUIRED: 'New Password is required',
    CONFIRMPASSWORDISREQUIRED: 'Confirm Passowrd is required',
    INVALIDOLDPASSWORD: 'Invalid old password',
    INVALIDNEWPASSWORD: 'Invalid new password',
    INVALIDCONFIRMPASSWORD: 'Invalid confirm password',
    OLDPASSWORDMINLENGTHSHOULDBE6: 'Old Password must be exactly 6 characters long.',
    CONFIRMPASSWORDMINLENGTHSHOULDBE6: 'Confirm Password must be exactly 6 characters long.',
    NEWPASSWORDMINLENGTHSHOULDBE6: 'New Password must be exactly 6 characters long.',
    CONFIRMPASSWORDINVALIDFORMAT: 'Confirm Password invalid format',
    NEWPASSWORDINVALIDFORMAT: 'New Password invalid format',
    OLDPASSWORDINVALIDFORMAT: 'Old Password invalid format',
    OLDPASSWORDMINLENGTHSHOULDBE8: 'Old Password minlegnth should be 8',
    NEWPASSWORDMINLENGTHSHOULDBE8: 'New Password minlegnth should be 8',
    CONFIRMPASSWORDMINLENGTHSHOULDBE8: 'Confirm Password minlegnth should be 8',
    NEWANDCONFIRMPASSWORDNOTSAME: 'New Password and Confirm Password are not same',
    NEWADNOLDPASSWORDCANTBESAME: 'New Password cannot be the same as the Old Password',

    //Staff set password (invite link)
    CREATEASTRONGPASSWORDTOACTIVATE: 'Create a strong password to activate your account.',
    INVALIDORLINKEXPIRED: 'This link is invalid or has expired. Please contact your administrator.',
    PASSWORDMUSTBESTRONG: 'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number and a special character.',
    PASSWORDSDONOTMATCH: 'Passwords do not match',

    //Subscription
    SUBSCRIPTION: 'Subscription',
    MAXADCOUNT: 'Max Banner Count',
    MAXNEWSCOUNT: 'Max News Count',
    ACTIVE: 'Active',
    NOTACTIVE: 'Not Active',
    ADDNEWSUBSCRIPTION: 'Add New Subscription',
    MAXADCOUNTISREQUIRED: 'Max banner count is required',
    MAXNEWSCOUNTISREQUIRED: 'Max news count is required',
    INVALIDMAXNEWSCOUNT: 'Invalid max news count',
    INVALIDMAXADCOUNT: 'Invalid max banner count',
    UPDATESUBSCRIPTION: 'Update Subscription',
    MINERROR: 'Invalid value. The value must be at least 1.',
    MINCOUNT: 'Minimum value allowed is 1.',
    MAXCOUNT: 'Maximum value allowed is 1000.',
    NOACCESSIBLEPAGES: 'No accessible pages for your account. Contact your administrator.',

    //Forgot Password
    ENTEREMAILTORESETPASSWORD: "Enter your email and we'll send you instructions to reset your password",
    ENTERMOBILETORESETPASSWORD: "Enter your mobile number and we'll send you an OTP to reset your password",
    EMAILADDRESS: 'Email Address',
    ENTEREMAILADDRESS: 'Enter email address',
    SEND: 'send',
    BACKTOLOGIN: 'Back to Login',
    PASSWORDUPDATED: 'Password updated successfully',

    //Reset Password
    RESETPASSWORD: 'Reset Password',
    YOURNEWPASSWORDMUSTBEDIFFERENT: 'Your new password must be different from previously used passwords',
    ENTERYOURPASSWORD: 'Enter your password',
    SETNEWPASSWORD: 'Set New Password',

    //Chat
    CHAT: 'Chat',
    CONVERSATION: 'Conversation',
    REPORTEDCHAT: 'Reported Chat',
    MESSAGES: 'Messages',
    ALLMESSAGES: 'All Messages',
    SELECTPARTNER: 'Select Partner',
    BLOCK: 'Block',
    REPORT: 'Report',
    UPLOADAVAILABLEBRANCHS: 'Upload Available Branchs',
    IMPORTREWARDSFROMEXCEL: 'Import Rewards from Excel',
    IMPORTREWARDSFROMEXCELSHORT: 'Import Rewards',
    IMPORTBRANCHESFROMEXCEL: 'Import Branches from Excel',
    REQUIREDIMPORTCOLUMNS: 'Required columns (must match the header row)',
    ROW: 'Row',
    ISREQUIRED: 'is required',
    ROWSREADYTOIMPORT: 'rows ready to import',
    VALIDBRANCHES: 'Valid Branches',
    IMPORT: 'Import',
    DOWNLOADTEMPLATE: 'Download Template',
    REWARDTIERISREQUIRED: 'Reward tier is required',
    ADDREWARDTIERFIRST: 'Add at least one reward tier before importing rewards.',
    FAILEDTOLOADIMPORTTEMPLATE: 'Could not load import template from the server.',
    EXCELEMPTYORSHEET: 'Excel file has no sheets or is empty.',
    NODATAINEXCEL: 'No data rows found under the header row.',
    REQUESTFAILED: 'Request failed',
    IMPORTREWARDSFINISHEDWITHERRORS: 'Import finished: {{successCount}} succeeded, {{failureCount}} failed.',
    BRANCHESIMPORTSUCCESS: 'Branches imported successfully',
    BLOCKIT: 'Yes, block it!',
    BLOCKEDSUCCESSFULLY: 'Blocked successfully!',
    BLOCKED: 'Blocked',
    USERISBLOCKED: 'User is blocked',
    DOWNLOADFILE: 'Download file',
    REPORTEDBY: 'Reported By',
    REPORTREASON: 'Report Reason',
    REPORTSTATUS: 'Report Status',
    ADMINACTION: 'Admin Action',
    WARNINGCOUNT: 'Warning Count',
    UPDATEREPORTEDCHAT: 'Update Reported Chat',
    NONEGATIVEVALUE: 'Only allows 0 or positive number',
    INVALIDADMINACTION: 'Invalid admin action',
    INVALIDREPORTSTATUS: 'Invalid report status',
    INVALIDREPORTREASON: 'Invalid report reason',
    REPORTEDCHATDETAIL: 'Reported Chat Detail',
    SELECTREPORTSTATUS: 'Select Report Status',
    MESSAGESENTSUCCESSFULLY: 'Message Sent Successfully',
    MESSAGE: 'Message',
    CANTSENDEMPTYMESSAGE: "Can't send empty message",
    UPLOADIMAGE: 'Upload Image',
    ONLYIMAGEFILEACCEPTHERE: 'Only image file accept here',
    IMAGEUPLOADSUCCESSFULLY: 'Image upload successfully',
    SENDMESSAGE: 'Send Message',
    DROPFILE: 'Drop files here or click to upload.',
    REPORTREASONISREQUIRED: 'Report Reason is required',
    REPORTSTATUSISREQUIRED: 'Report Status is required',
    ADMINACTIONISREQUIRED: 'Admin Action is required',
    ADMINREVIEWPENDING: 'Admin review pending',
    REPORTIT: 'Report it',
    NOACTIONTAKEN: 'No action taken',
    WARNINGISSUED: 'Warning Issued',
    REPORTEDSUCCESSFULLY: 'Reported Successfully',
    USERBLOCKEDTHECHAT: 'User blocked the chat',
    UNBLOCKTHECHAT: 'Do you want to unblock this chat now?',
    UNBLOCKIT: 'Unblock It',
    UNBLOCK: 'Unblock',
    UNBLOCKEDTSUCCESSFULLY: 'Unblocked Successfully',

    //Product Catalogue
    PRODUCTCATALOGUE: 'Product Catalogue',
    UPDATEPRODUCTCATALOGUE: 'Update Product Catalogue',
    ADDNEWPRODUCTCATALOGUE: 'Add New Product Catalogue',
    FILTERS: 'Filters',
    SELECTCATEGORY: 'Select Category',
    SELECTSUBCATEGORY: 'Select Subcategory',
    SELECTBRAND: 'Select Brand',
    APPLYFILTER: 'Apply',
    RESETFILTER: 'Reset',
    UPLOADPRODUCTCATALOGUE: 'Upload Product Catalogue',
    BARCODE: 'Bar Code',
    SUBCATEGORY1: 'Subcategory 1',
    SUBCATEGORY2: 'Subcategory 2',
    SUBCATEGORY3: 'Subcategory 3',
    SELECTSUBCATEGORY1: 'Select Subcategory 1',
    SELECTPRODUCTNAME: 'Select Product Name',
    SELECTSTORE: 'Select Store',
    INVALIDRECORD: 'Invalid Record',

    //CATEGORIES
    CATEGORIES: 'Categories',
    UPDATESUBCATEGORY1: 'Update Subcategory1',
    ADDNEWSUBCATEGORY1: 'Add New Subcategory1',
    UPDATESUBCATEGORY2: 'Update Subcategory2',
    ADDNEWSUBCATEGORY2: 'Add New Subcategory2',
    UPDATESUBCATEGORY3: 'Update Subcategory3',
    ADDNEWSUBCATEGORY3: 'Add New Subcategory3',
    SUBCATEGORY3ISREQUIRED: 'Subcategory3 is required',
    SUBCATEGORY2ISREQUIRED: 'Subcategory2 is required',
    SUBCATEGORY1ISREQUIRED: 'Subcategory1 is required',
    UPLOADCATEGORY: 'Upload Category',
    VALIDCATEGORIES: 'Valid Categories',
    UPLOADSUBCATEGORY1: 'Upload Subcategory1',
    VALIDSUCATEGORIES1: 'Valid Subcategories1',
    UPLOADSUBCATEGORY2: 'Upload Subcategory2',
    VALIDSUCATEGORIES2: 'Valid Subcategories2',
    UPLOADSUBCATEGORY3: 'Upload Subcategory3',
    VALIDSUCATEGORIES3: 'Valid Subcategories3',

    //TARGETED MARKETING
    TARGETEDMARKETING: 'Targeted Marketing',
    UPDATETARGETEDMARKETING: 'Update Targeted Marketing',
    ADDTARGETEDMARKETING: 'Add Targeted Marketing',
    WEEKSELECTION: 'Week Selection',
    ADSTYPE: 'Ads Type',
    ADS: 'Ads',
    TSUBCATEGORY3: 'Sub Category 3',
    AGE: 'Age',
    CLIENTTYPE: 'Client Type',
    TARGETEDMARKETINGLIST: 'Targeted Marketing List',
    WEEKSELECTIONISREQUIRED: 'Week is Required',
    INVALIDWEEKSELECTION: 'Invalid Selection',
    ADSTYPEISREQUIRED: 'Ads Type is Required',
    INVALIDADSTYPE: 'Invalid Ads Type',
    ADSISREQUIRED: 'Ads is Required',
    USERTYPEISREQUIRED: 'User Type is Required',
    INVALIDUSERTYPE: 'Invalid User Type',
    CALCULATEUSERS: 'Calculate Users',
    CAMPAIGNNAME: 'Campaign Name',
    CAMPAIGNDESCRIPTION: 'Campaign Description',
    SUBSUBCATEGORY: 'Sub Sub Category',
    SUBSUBCATEGORYISREQUIRED: 'Sub Sub Category is Required',
    INVALIDSUBSUBCATEGORY: 'Invalid Sub Sub Category',
    CAMPAIGNNAMEISREQUIRED: 'Campaign Name is Required',
    INVALIDCAMPAIGNNAME: 'Invalid Campaign Name',
    VALIDATEANDSUBMIT: 'Validate and Submit',
    CAMPAIGNDESCRIPTIONISREQUIRED: 'Campaign Description is Required',
    INVALIDCAMPAIGNDESCRIPTION: 'Invalid Campaign Description',
    CURRENT: 'Current',
    NORECORD: 'No Record',
    ALLPRODUCT: 'All Product',
    AGEISREQUIRED: 'Age is Required',
    EXISTINGUSERDATADELETEWARNING: 'Please Note: Updating this campaign will permanently delete all existing user data associated with it.',
    DESIREDUSERREACHMUSTBEGREATERTHANZERO: 'Desired user reach must be greater then zero',
    DESIREDUSERREACHISREQUIRED: 'Desired user reach is required',
    THISSPINALREADYLINKTOATARGETEDMARGETING: 'This spin is already linked to a campaign and cannot be updated.',
    PLEASEREMOVECAMPIGNBRFOREDELETETHERECORD: 'Please remove the campaign before delete the record.',
    THISNEWSALREADYLINKTOATARGETEDMARGETING: 'This news is already linked to a campaign and cannot be updated.',
    THISBANNERALREADYLINKTOATARGETEDMARGETING: 'This banner is already linked to a campaign and cannot be updated.',
    RESELCETCALCULATEUSER: 'Reselect Filters',
    LOCATIONISREQUIRED: 'Location is required',
    DISTANCEINKM: 'Distance in KM',
    DISTANCEMAX110: 'Max distance is 110',
    DISTANCEMIN10: 'Min distance is 10',
    DISTANCEISREQUIRED: 'Distance is required',
    SELECT: 'Select',

    //BRAND
    ADDNEWBRAND: 'Add New Brand',
    UPDATEBRAND: 'Update Brand',

    //OPENAI PROMPT
    OPENAIPROMPT: 'OpenAI Prompt',
    OPENAIPROMPTCONTEXT: 'OpenAI Prompt Context',
    UPDATEOPENAIPROMPT: 'Update OpenAI Prompt',
    CONTEXT: 'Context',
    CONTEXTISREQUIRED: 'Context is required',
    INVALIDCONTEXT: 'Invalid context',
    EDIT: 'Edit',
    PRODUCTNAMELISTUPDATEMESSAGE: 'Please note that this process will utilize OpenAI input tokens. Would you like to proceed?',
    PRODUCTNAMELISTUPDATEDSUCCESSFULLY: 'SKU list has beeen updated successfully.',
    FILESUPLOADEDSUCCESSFULLY: 'Files uploaded successfully',
    UPDATESKULISTTOOPENAI: 'Update SKU list to OpenAI',
    UPDATEFILESINTOOPENAI: 'Update files into openAI',
    UPDATEFILE: 'Update Config Brand Main, Config Store Main and Subcategory2 Files',

    //HOBBIES INTEREST
    HOBBIESINTEREST: 'Hobbies & Interest',
    HOBBYINTERESTCATEGORY: 'Hobby Interest Category',
    HOBBYINTERESTITEM: 'Hobby Interest Item',
    ADDNEWHOBBYINTERESTCATEGORY: 'Add New Hobby Interest Category',
    UPDATEHOBBYINTERESTCATEGORY: 'Update Hobby Interest Category',
    UPLOADHOBBYINTERESTCATEGORY: 'Upload Hobby Interest Category',
    HOBBYINTERESTCATEGORYNAME: 'Hobby Interest Category Name',
    USERSLINKEDTOHOBBYINTERESTCATEGORY: 'Update not allowed. This Hobby Interest category is linked to users.',
    ADDNEWHOBBYINTERESTITEM: 'Add New Hobby Interest Item',
    UPDATEHOBBYINTERESTITEM: 'Update Hobby Interest Item',
    HOBBYINTERESTCATEGORYISREQUIRED: 'Hobby Interest Category is required',
    INVALIDHOBBYINTERESTCATEGORY: 'Invalid hobby interest category',
    UPLOADHOBBYINTERESTITEM: 'Upload Hobby Interest Item',
    VALIDHOBBYINTERESTITEMS: 'Valid Hobby Interest Items',
    VALIDHOBBYINTERTESTCATEGORIES: 'Valid Hobby Interest Categories',

    //DELIVERY
    DELIVERY: 'Delivery',
    DELIVERYMETHODS: 'Delivery Methods',
    NOTE: 'Note',
    FEES: 'Fees',
    DELIVERYDETAILS: 'Delivery Details',
    ID: 'ID',
    ESTIMATEDATETIME: 'Estimated date',
    PENDINGDELIVERIES: 'Pending deliveries',
    BRANDNAME: 'Brand Name',
    CONSUMERDEMANDQUANTITY: 'Consumer Demand Quantity',
    AVAILABLESTOCKATNETGLOBAL: 'Available Stock at NetGlobal',
    REQUIREDBRANDSHIPMENT: 'Required Brand Shipment',
    REMAININGQUANTITY: 'Remaining Quantity',
    STATUSUPDATEDSUCCESSFULLY: 'Status updated successfully',
    DELIVERYTRACKING: 'Delivery Tracking',
    CONSUMERDELIVERYID: 'Consumer delivery ID',
    PROCESS_WITH_NETGLOBAL: 'Process with Net Global',

    //BRANCH
    BRANCH: 'Branch',
    BRANCHNAMEISREQUIRED: 'Branch Name is required',
    INVALIDBRANCH: 'Invalid Branch',
    ADDNEWBRANCH: 'Add New Branch',
    UPDATEBRANCH: 'Update New Branch',
    REWARDINVENTORY: 'Reward inventory',
    MONEYREWARDINVENTORY: 'Money reward inventory',
    REDEEMEDDATETIME: 'Redeemed Date time',
    MONEYAMOUNT: 'Money Amount',
    TOTALREWARDS: 'Total Rewards',
    TOTALMONEY: 'Total Money',
    DRAGDROPIMAGE: 'Drag & Drop Image',
    ORCLICKTOUPLOAD: 'Or click to upload',
  },
};
